import { assert } from '@Utils/assert';
import isEmpty from 'lodash/isEmpty';
import { FEATURES } from '@Constants/rx-ui/constants';
import { isFeatureEnabled } from '@Services/Auth/AuthHelper';

import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';

export async function getAllAlertsAsync(force) {
  const alerts = await MessageBroker.send(RequestUrls.getAllAlertsV2, null, { cache: !force });

  // eslint-disable-next-line no-use-before-define
  return normalizeGetAllAlertsAsyncResponse(alerts);
}

export function normalizeGetAllAlertsAsyncResponse(alerts) {
  // eslint-disable-next-line no-use-before-define
  return alerts.map(normalizeAlertItem);
}

export function normalizeAlertItem(alert) {
  const { alertsItem } = alert;
  const { alertUuid } = alertsItem;

  return {
    ...alert,
    id: alertUuid,
  };
}

export function deleteAlertAsync(params) {
  assert(
    !isEmpty(params.uuid),
    `"params.uuid" has to be defined, it is taken from alert.alertsItem.alertUuid which is same as alert.alertsItem.id after normalization`
  );

  return MessageBroker.send(RequestUrls.removeAlertV2, params);
}

export function getAlertsInfo(params) {
  assert(!isEmpty(params.context), `"params.context" has to be defined, taken from alert.alertsItem.context`);

  return MessageBroker.send(RequestUrls.getAlertInfoV2, params, { cache: false });
}

export function importAlertsWhereClause(params) {
  assert(!isEmpty(params.databaseId), `"params.databaseId" has to be defined`);
  assert(!isEmpty(params.whereClauseImportToken), `"params.whereClauseImportToken" has to be defined`);

  return MessageBroker.send(RequestUrls.importWhereClause, params);
}

// This is for testing retroactively created alerts
function _checkCreateAlertDaysBeforeNow(alert) {
  const createAlertDaysBeforeNow =
    !isFeatureEnabled(FEATURES.disableReactAlertsPage) && isFeatureEnabled(FEATURES.createAlertDaysBeforeNow);

  return {
    ...alert,
    // eslint-disable-next-line radix
    ...(createAlertDaysBeforeNow && { createAlertDaysBeforeNow: parseInt(createAlertDaysBeforeNow) }),
  };
}

export function createAlert(alert) {
  return MessageBroker.send(RequestUrls.createAlertV2, _checkCreateAlertDaysBeforeNow(alert));
}

export function updateAlert(alert) {
  return MessageBroker.send(RequestUrls.modifyAlertV2, _checkCreateAlertDaysBeforeNow(alert));
}
